import React from 'react';
export function KitContents() {
  return <section className="bg-gray-50 py-4 md:py-5 px-4 border-t border-gray-100" data-id="element-236">
      <div className="max-w-5xl mx-auto" data-id="element-237">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-3" data-id="element-238">
          📦 ¿QUÉ INCLUYE EL KIT?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-239">
          {/* Tomo 1 */}
          <div className="bg-white p-3 rounded-xl border border-gray-100 shadow-sm flex gap-3" data-id="element-240">
            <div className="flex-shrink-0" data-id="element-241">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-bold text-lg" data-id="element-242">
                1
              </div>
            </div>
            <div data-id="element-243">
              <h3 className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-244">
                📘 TOMO 1 — Mentalidad, Ahorro y Presupuesto
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-245">
                El dinero como herramienta. Presupuesto, ahorro, inflación y
                metas SMART adaptadas al adolescente argentino.
              </p>
            </div>
          </div>

          {/* Tomo 2 */}
          <div className="bg-white p-3 rounded-xl border border-gray-100 shadow-sm flex gap-3" data-id="element-246">
            <div className="flex-shrink-0" data-id="element-247">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-bold text-lg" data-id="element-248">
                2
              </div>
            </div>
            <div data-id="element-249">
              <h3 className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-250">
                📗 TOMO 2 — El Sistema Financiero Argentino
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-251">
                BCRA, bancos, billeteras virtuales, tipos de cambio y el sistema
                de pagos QR explicados para secundaria.
              </p>
            </div>
          </div>

          {/* Tomo 3 */}
          <div className="bg-white p-3 rounded-xl border border-gray-100 shadow-sm flex gap-3" data-id="element-252">
            <div className="flex-shrink-0" data-id="element-253">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-bold text-lg" data-id="element-254">
                3
              </div>
            </div>
            <div data-id="element-255">
              <h3 className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-256">
                📙 TOMO 3 — Crédito, Deuda e Inflación
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-257">
                TNA, TEA, CFT, tarjeta de crédito, Veraz e historial crediticio.
                El costo real del dinero en Argentina.
              </p>
            </div>
          </div>

          {/* Tomo 4 */}
          <div className="bg-white p-3 rounded-xl border border-gray-100 shadow-sm flex gap-3" data-id="element-258">
            <div className="flex-shrink-0" data-id="element-259">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-bold text-lg" data-id="element-260">
                4
              </div>
            </div>
            <div data-id="element-261">
              <h3 className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-262">
                📕 TOMO 4 — Inversiones y Mercado de Capitales
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-263">
                Acciones, bonos, CEDEARs, criptomonedas y cómo construir la
                primera cartera desde Argentina.
              </p>
            </div>
          </div>

          {/* Tomo 5 */}
          <div className="bg-white p-3 rounded-xl border border-gray-100 shadow-sm flex gap-3" data-id="element-264">
            <div className="flex-shrink-0" data-id="element-265">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-bold text-lg" data-id="element-266">
                5
              </div>
            </div>
            <div data-id="element-267">
              <h3 className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-268">
                📒 TOMO 5 — Emprendedurismo y Monotributo
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-269">
                De la idea al negocio. Costos, precios, punto de equilibrio,
                Monotributo y marketing sin presupuesto.
              </p>
            </div>
          </div>

          {/* Tomo 6 */}
          <div className="bg-white p-3 rounded-xl border border-gray-100 shadow-sm flex gap-3" data-id="element-270">
            <div className="flex-shrink-0" data-id="element-271">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-bold text-lg" data-id="element-272">
                6
              </div>
            </div>
            <div data-id="element-273">
              <h3 className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-274">
                📓 TOMO 6 — Ciberseguridad y Estafas Digitales
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-275">
                Phishing, vishing, fraude del DEBIN, contraseñas seguras y
                protocolo de emergencia ante estafas.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-4 text-center" data-id="element-276">
          <span className="inline-block bg-gray-900 text-white font-bold text-sm px-4 py-2 rounded-lg" data-id="element-277">
            360 páginas · 6 tomos · Alineado NAP 2026
          </span>
        </div>
      </div>
    </section>;
}